var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{class:_vm.$style.container},_vm._l((_vm.addDeviceCards),function(wayToAddDevice,index){return _c('li',{key:index,class:_vm.$style.cards},[_c('WayToAddDeviceCard',{attrs:{"wayToAddDevice":wayToAddDevice}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }